import controller from './autocomplete.controller';

const template = require('./autocomplete.html');

export default {
    bindings: {
        onSearch: '&',
        onChange: '&',
        onSelected: '&',
        textKey: '@',
        placeholder: '@'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/common/search-autocomplete/autocomplete.component.js